/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { IThresholdCrossingSettingProfile, IThresholdCrossingSettingAction, IKpi, IThresholdCrossingSettingRule, IThresholdCrossingSettingSchedule,IEmailGroup,ISnmpGroup } from "../../../../store/api/admin/types";
import { setBasicDialogOpenFor, setConfirmDialog, setOpenCustomDailog, setIsLoadingStatus, setOpenToast } from "../../../../store/helpers/helperReducers";
import { isEqualString, errorMessage, getMissingValues,titleCase } from "../../../../utils/helpers";
import { errorMsgSelector } from "../../../../store/helpers/helperSelectors";
import { IKeyValue } from "../../types";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { useStoreDispatch } from "../../../../store/hooks";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { setNoOfSelectedRow } from "../../../../store/api/devices/reducers"; 
import { useGetEmailGroupsQuery,useGetNorthboundGroupsQuery } from "../../../../store/api/admin/adminApiSlice";
import { IOption } from "../../../Shared/Filter/types"
import { useCreateThresholdCrossingSettingProfileMutation, 
  useGetThresholdCrossingSettingProfileQuery, 
  useUpdateThresholdCrossingSettingProfileMutation ,
  useDeleteThresholdCrossingSettingProfileMutation,
  useCreateThresholdCrossingSettingActionMutation,
  useUpdateThresholdCrossingSettingActionMutation ,
  useDeleteThresholdCrossingSettingActionMutation,
  useCreateThresholdCrossingSettingScheduleMutation,
  useUpdateThresholdCrossingSettingScheduleMutation ,
  useDeleteThresholdCrossingSettingScheduleMutation,
  useCreateThresholdCrossingSettingRuleMutation,
  useUpdateThresholdCrossingSettingRuleMutation ,
  useDeleteThresholdCrossingSettingRuleMutation,
} from "../../../../store/api/admin/adminApiSlice";
import { thresholdCrossingSettingProfilePayload, thresholdCrossingSettingActionPayload, thresholdCrossingSettingSchedulePayload, thresholdCrossingSettingRulePayload } from "../../../helpers";
import { selectedThresholdCrossingSettingProfileSelector,selectedThresholdCrossingSettingActionSelector,selectedThresholdCrossingSettingScheduleSelector, selectedThresholdCrossingSettingRuleSelector,isAddEditDeleteThresholdCrossingSettingProfileSelector,isAddEditDeleteThresholdCrossingSettingActionSelector,isAddEditDeleteThresholdCrossingSettingRuleSelector } from "../../../../store/api/admin/selectors";
import { constStr } from "../../../../globals/constants";
import { basicDialogSelector } from "../../../../store/helpers/helperSelectors";
import { setIsAddEditDeleteThresholdCrossingSettingProfile,setIsAddEditDeleteThresholdCrossingSettingAction, setIsAddEditDeleteThresholdCrossingSettingSchedule,setIsAddEditDeleteThresholdCrossingSettingRule } from "../../../../store/api/admin/reducers";


interface IPayload {
  [key: string]: string;
}

export const useThresholdCrossingSetting = () => {
  const { data : profileList = [], isLoading, refetch } = useGetThresholdCrossingSettingProfileQuery();

  const dispatch = useStoreDispatch();
  const [anchorElThresholdCrossingSettingProfile, setAnchorElThresholdCrossingSettingProfile] = useState<null | HTMLElement>(null);
  const selectedThresholdCrossingSettingProfile = useSelector(selectedThresholdCrossingSettingProfileSelector);
  const [deleteThresholdCrossingSettingProfile, deleteThresholdCrossingSettingProfileStatus] = useDeleteThresholdCrossingSettingProfileMutation();

  const selectedThresholdCrossingSettingRule = useSelector(selectedThresholdCrossingSettingRuleSelector);
  const [deleteThresholdCrossingSettingRule, deleteThresholdCrossingSettingRuleStatus] = useDeleteThresholdCrossingSettingRuleMutation();
  
  const selectedThresholdCrossingSettingAction = useSelector(selectedThresholdCrossingSettingActionSelector);
  const [deleteThresholdCrossingSettingAction, deleteThresholdCrossingSettingActionStatus] = useDeleteThresholdCrossingSettingActionMutation();
  
  const [deleteThresholdCrossingSettingSchedule, deleteThresholdCrossingSettingScheduleStatus] = useDeleteThresholdCrossingSettingScheduleMutation();

  const basicDialogOpenFor = useSelector(basicDialogSelector);

  const deleteThresholdCrossingSettingProfileHandler = () => {
    dispatch(setConfirmDialog(DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGPROFILE));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGPROFILE))
    setAnchorElThresholdCrossingSettingProfile(null);
  };

  const handleOnActionRowSelected = (rowIds: GridRowSelectionModel) => {
    dispatch(setNoOfSelectedRow({ deviceRowIds: rowIds }));
  };

  // const deleteThresholdCrossingSettingProfileClickAction = async (actionName: string,profile: IThresholdCrossingSettingProfile) => {
  //   if (!actionName) return;
  //   if (actionName.match(constStr.yesDelete.toLowerCase())) {
  //       if (basicDialogOpenFor === DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGPROFILE) {
  //        try {
  //           let response: any;
  //           let messageStr = `The deletion process for ${profile?.name} has been initiated.`;
  //             response = await deleteThresholdCrossingSettingProfile(profile?.id);
  //             if (response?.error) throw response.error;
  //             if (response?.data?.status === 204) {
  //               dispatch(setIsAddEditDeleteThresholdCrossingSettingProfile(true));
  //               dispatch(
  //                 setOpenToast({
  //                   openToast: true,
  //                   toastType: "success",
  //                   message: `${messageStr}`,
  //                 })
  //               );
  //             }
  //         } catch (error: any) {
  //           dispatch(setIsAddEditDeleteThresholdCrossingSettingProfile(false));
  //           dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
  //         }
  //       }
  //   }
  // };

  const deleteThresholdCrossingSettingActionClickAction = async (actionName: string) => {
    if (!actionName) {
      dispatch(setBasicDialogOpenFor(undefined));
      return;
    }
    if (actionName.match(constStr.yesDelete.toLowerCase())) {
      if (basicDialogOpenFor === DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGACTION) {
        try {
          let response: any;
          let messageStr = `The ${titleCase(selectedThresholdCrossingSettingAction?.actionType)} action has been deleted from the Profile.`;
            response = await deleteThresholdCrossingSettingAction(selectedThresholdCrossingSettingAction?.id);
            if (response?.error) throw response.error;
            if (response?.data?.status === 204) {
              dispatch(setIsAddEditDeleteThresholdCrossingSettingAction(true));
              dispatch(
                setOpenToast({
                  openToast: true,
                  toastType: "success",
                  message: `${messageStr}`,
                })
              );
            }
        } catch (error: any) {
        dispatch(setIsAddEditDeleteThresholdCrossingSettingAction(false));
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
      }
        }
    }
  };

  const deleteThresholdCrossingSettingScheduleClickAction = async (actionName: string,schedule: IThresholdCrossingSettingSchedule) => {
    if (!actionName) return;
    if (actionName.match(constStr.yesDelete.toLowerCase())) {
        if (basicDialogOpenFor === DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGSCHEDULE) {
         try {
            let response: any;
            let messageStr = "The Schedule has been deleted from the profile.";
              response = await deleteThresholdCrossingSettingSchedule(schedule?.id);
              if (response?.error) throw response.error;
              if (response?.data?.status === 204) {
                dispatch(setIsAddEditDeleteThresholdCrossingSettingSchedule(true));
                dispatch(
                  setOpenToast({
                    openToast: true,
                    toastType: "success",
                    message: `${messageStr}`,
                  })
                );
              }
          } catch (error: any) {
            dispatch(setIsAddEditDeleteThresholdCrossingSettingSchedule(false));
            dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
          }
        }
    }
  };

  const deleteSchedule = async (schedule: IThresholdCrossingSettingSchedule) => {
    try {
      const messageStr = `The deletion process for days ${schedule?.days} has been initiated.`;
      const response: any = await deleteThresholdCrossingSettingSchedule(schedule?.id);
      if (response?.error) throw response.error;
      if (response?.data?.status === 204) {
        dispatch(setIsAddEditDeleteThresholdCrossingSettingSchedule(true));
        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "success",
            message: `${messageStr}`,
          })
        );
      }
    } catch (error: any) {
      dispatch(setIsAddEditDeleteThresholdCrossingSettingSchedule(false));
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  

  const deleteThresholdCrossingSettingRuleClickAction = async (actionName: string) => {
    if (!actionName) {
      dispatch(setBasicDialogOpenFor(undefined));
      return;
    }
    if (actionName.match(constStr.yesDelete.toLowerCase())) {
      if (basicDialogOpenFor === DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGRULE) {
        try {
          let response: any;
          let messageStr = `The Rule has been deleted successfully for ${titleCase(selectedThresholdCrossingSettingRule?.kpiType)}.`;
            response = await deleteThresholdCrossingSettingRule(selectedThresholdCrossingSettingRule?.id);
            if (response?.error) throw response.error;
            if (response?.data?.status === 204) {
              dispatch(setIsAddEditDeleteThresholdCrossingSettingRule(true));
              dispatch(
                setOpenToast({
                  openToast: true,
                  toastType: "success",
                  message: `${messageStr}`,
                })
              );
            }
        } catch (error: any) {
        dispatch(setIsAddEditDeleteThresholdCrossingSettingRule(false));
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
      }
        }
    }
  };

  const handleOnRuleRowSelected = (rowIds: GridRowSelectionModel) => {
    dispatch(setNoOfSelectedRow({ deviceRowIds: rowIds }));
  };
  
  return {
    profileList,
    handleOnActionRowSelected,
    handleOnRuleRowSelected,
    anchorElThresholdCrossingSettingProfile,
    setAnchorElThresholdCrossingSettingProfile,
    deleteThresholdCrossingSettingProfileHandler,
    //deleteThresholdCrossingSettingProfileClickAction,
    deleteThresholdCrossingSettingActionClickAction,
    deleteThresholdCrossingSettingRuleClickAction,
    deleteThresholdCrossingSettingScheduleClickAction,
    deleteSchedule
  };
};


export const useThresholdCrossingSettingProfileData = (selectedThresholdCrossingSettingProfile: IThresholdCrossingSettingProfile, onProfileCreated?: (profileId: number) => void) => {
  const name = "name";
  const description = "description";
  const enabled = "enabled";
  const [thresholdCrossingSettingProfileData, setThresholdCrossingSettingProfileData] = useState<IThresholdCrossingSettingProfile>(selectedThresholdCrossingSettingProfile);
  const [errMsg, setErrMsg] = useState<IPayload>({});
  const errorMsg = useSelector(errorMsgSelector);

  const [createThresholdCrossingSettingProfile, createThresholdCrossingSettingProfileStatus] = useCreateThresholdCrossingSettingProfileMutation();
  const [updateThresholdCrossingSettingProfile, updateThresholdCrossingSettingProfileStatus] = useUpdateThresholdCrossingSettingProfileMutation();
  
  const { data : profileList = [], isLoading, refetch } = useGetThresholdCrossingSettingProfileQuery();

  const dispatch = useStoreDispatch();
  const handleValidate = () => {
    let valid: any = true;
    if (thresholdCrossingSettingProfileData?.name === "") {
      setErrMsg({ ...errMsg, name: `Name is required` });
      valid = false;
    }
    return valid;
  };

  const onBlurHandler = (event: any) => {
    const { name, value } = event?.target;
    if(name === "name")
    {
      if (!!value) {
        if (IsProfileAlreadyExist(value,thresholdCrossingSettingProfileData.id)) {
          setErrMsg({ name: "Profile name is already in use" });
          return;
        }
        else{
          setErrMsg({ ...errMsg, [name]: "" });
        }
      }
      else if (!!!value) {
        setErrMsg({ ...errMsg, [name]: `Profile name is required!` });
      }else{
          setErrMsg({ ...errMsg, [name]: "" });
        }

    }
  };
  
  const IsProfileAlreadyExist = (profileName: string, profileId? : number) => {
    let isAlreadyExist: boolean = false;
    if(profileId === null || profileId === 0)
    {
      isAlreadyExist = profileList?.length > 0 && profileList.some((item: IThresholdCrossingSettingProfile) => isEqualString(item.name, profileName));
    }
    else{
      isAlreadyExist = profileList?.length > 0 && profileList.some((item: IThresholdCrossingSettingProfile) => isEqualString(item.name, profileName) && item.id !== profileId);
    }
    return isAlreadyExist;
  };
  
  const submitHandler = async () => {
    if(handleValidate() && !errorsPresent)
    {
      let result: any;
      if (IsProfileAlreadyExist(thresholdCrossingSettingProfileData.name, thresholdCrossingSettingProfileData.id)) {
        setErrMsg({ name: "profile name is already in use" });
        return;
      }
      try{
        let isNewProfile = thresholdCrossingSettingProfileData.id === null || thresholdCrossingSettingProfileData.id === 0;
        if (isNewProfile) {
          result = await createThresholdCrossingSettingProfile(thresholdCrossingSettingProfilePayload(thresholdCrossingSettingProfileData));
        }
        else
        {
          result = await updateThresholdCrossingSettingProfile(thresholdCrossingSettingProfilePayload(thresholdCrossingSettingProfileData));
        }
        if (result?.error) throw result?.error;
          if (result.data?.status === 200 || result.data?.status === 201) {
            dispatch(setBasicDialogOpenFor(undefined));
            dispatch(
              setOpenToast({
                openToast: true,
                toastType: "success",
                message: `The Profile ${titleCase(thresholdCrossingSettingProfileData.name)} has been ${isNewProfile ? "added" : "updated"} successfully.`,
              })
            );
            
            // If a new profile was created and onProfileCreated callback is provided, call it with the new profile ID
            if (isNewProfile && onProfileCreated) {
              // Try to get the ID from the response - check multiple possible paths
              const newProfileId = result.data?.data?.id || result.data?.id;
              if (newProfileId) {
                onProfileCreated(newProfileId);
              }
            }
            
            refetch();
          }

      }catch (error: any) {
          dispatch(setBasicDialogOpenFor(undefined));
          dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
      }
   }
  };

  const keys = [name, description];
  const errorMsglist = keys.reduce((acc: IKeyValue, k) => {
    acc[k] = errorMsg[k] ?? '';
    return acc;
  }, {});
  const errorsPresent = Object.values(errorMsglist).some((err) => err !== "");

  return {
    thresholdCrossingSettingProfileData,
    setThresholdCrossingSettingProfileData,
    submitHandler,
    onBlurHandler,
    errMsg,
    setErrMsg,
    errorsPresent,
    isLoading,
    name,
    description,
    enabled,
    profileList
  };
};

export const useThresholdCrossingSettingActionData = (selectedThresholdCrossingSettingAction: IThresholdCrossingSettingAction) => {
  const actionType="actionType";
  const details ="details";
  const [thresholdCrossingSettingActionData, setThresholdCrossingSettingActionData] = useState<IThresholdCrossingSettingAction>(selectedThresholdCrossingSettingAction);
 
  const [errMsg, setErrMsg] = useState<IPayload>({});
  const errorMsg = useSelector(errorMsgSelector);
  const dispatch = useStoreDispatch();

  const { data: emailGroupData = [], refetch: refetchEmailGroup } = useGetEmailGroupsQuery();
  const [emailGroupName, setEmailGroupName] = useState<IOption[]>([]);
  const emailGroupNameOptions: IOption[] =(emailGroupData?.length > 0 && emailGroupData?.map((item: IEmailGroup) => ({ title: item.id?.objectKey, value: item.id?.objectKey }))) || [];

  const args = {
    filters: "",
    deviceKey: "",
    search: "",
  }
  const { data: snmpGroupData = [], refetch: refetchSnmpGroup } = useGetNorthboundGroupsQuery(args);
  const [snmpGroupName, setSnmpGroupName] = useState<IOption[]>([]);
 
  const snmpGroupNameOptions: IOption[] =
  snmpGroupData?.map((item) => ({
    title: item.name,
    value: item.objectKey ?? "",   
  })) ?? [];

  const [createThresholdCrossingSettingAction, createThresholdCrossingSettingActionStatus] = useCreateThresholdCrossingSettingActionMutation();
  const [updateThresholdCrossingSettingAction, updateThresholdCrossingSettingActionStatus] = useUpdateThresholdCrossingSettingActionMutation();


  const [anchorElThresholdCrossingSettingAction, setAnchorElThresholdCrossingSettingAction] = useState<null | HTMLElement>(null);
  
  const deleteThresholdCrossingSettingActionHandler = () => {
    dispatch(setConfirmDialog(DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGACTION));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGACTION))
    setAnchorElThresholdCrossingSettingAction(null);
  };

  const handleValidate = () => {
    let valid: any = true;
    if (thresholdCrossingSettingActionData?.actionType === "") {
      setErrMsg({ ...errMsg, actionType: `Select Action is required` });
      valid = false;
    }
    if (thresholdCrossingSettingActionData?.details.length <= 0) {
      setErrMsg({ ...errMsg, details: `Select Details is required` });
      valid = false;
    }
    return valid;
  };

  const onBlurHandler = (event: any) => {
    const { name, value } = event?.target;
    
  };

  const submitHandler = async () => {
    if(handleValidate() && !errorsPresent)
    {
      let result: any;
      try{
        let isNewAction = thresholdCrossingSettingActionData.id === null || thresholdCrossingSettingActionData.id === 0;
        if (isNewAction) {
          result = await createThresholdCrossingSettingAction(thresholdCrossingSettingActionPayload(thresholdCrossingSettingActionData));
        }
        else
        {
          result = await updateThresholdCrossingSettingAction(thresholdCrossingSettingActionPayload(thresholdCrossingSettingActionData));
        }

        if (result?.error) throw result?.error;
          if (result.data?.status === 200 || result.data?.status === 201) {
            dispatch(setBasicDialogOpenFor(undefined));
            dispatch(setIsAddEditDeleteThresholdCrossingSettingAction(true));
            dispatch(
              setOpenToast({
                openToast: true,
                toastType: "success",
                message: `The ${titleCase(thresholdCrossingSettingActionData.actionType)} action has been ${isNewAction ? "added to" : "updated in"} the Profile.`,
              })
            );
          }
      }catch (error: any) {
          dispatch(setBasicDialogOpenFor(undefined));
           dispatch(setIsAddEditDeleteThresholdCrossingSettingAction(false));
          dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
      }
   }
  };

  const keys = [actionType, details];
  const errorMsglist = keys.reduce((acc: IKeyValue, k) => {
    acc[k] = errorMsg[k] ?? '';
    return acc;
  }, {});
  const errorsPresent = Object.values(errorMsglist).some((err) => err !== "");

  return {
    thresholdCrossingSettingActionData,
    setThresholdCrossingSettingActionData,
    submitHandler,
    onBlurHandler,
    errMsg,
    setErrMsg,
    errorsPresent,
    anchorElThresholdCrossingSettingAction,
    setAnchorElThresholdCrossingSettingAction,
    deleteThresholdCrossingSettingActionHandler,
    emailGroupNameOptions,
    snmpGroupNameOptions,
    emailGroupName,
    setEmailGroupName,
    actionType,
    details,
    snmpGroupName, 
    setSnmpGroupName
  };
};

export const useThresholdCrossingSettingScheduleData = (
  selectedThresholdCrossingSettingSchedule: IThresholdCrossingSettingSchedule,
  scheduleList: IThresholdCrossingSettingSchedule[] = []
) => {
  const days = "days";
  const fromTimes = "fromTime";
  const toTimes = "toTime";
  const [thresholdCrossingSettingScheduleData, setThresholdCrossingSettingScheduleData] = useState<IThresholdCrossingSettingSchedule>(selectedThresholdCrossingSettingSchedule);
  const [errMsg, setErrMsg] = useState<IPayload>({});
  const errorMsg = useSelector(errorMsgSelector);
  const dispatch = useStoreDispatch();

  const [createThresholdCrossingSettingSchedule, createThresholdCrossingSettingScheduleStatus] = useCreateThresholdCrossingSettingScheduleMutation();
  const [updateThresholdCrossingSettingSchedule, updateThresholdCrossingSettingScheduleStatus] = useUpdateThresholdCrossingSettingScheduleMutation();

  const handleValidate = () => {
    let valid: any = true;
    const days = thresholdCrossingSettingScheduleData?.days;
    const fromTime = thresholdCrossingSettingScheduleData?.toTime;
    const toTime = thresholdCrossingSettingScheduleData?.fromTime;
  
    if(days.length === 0)
    {
      setErrMsg({...errMsg, ["days"]: "days is required"});
      valid = false;
    }

    if(toTime === "")
    {
      setErrMsg({...errMsg, ["toTime"]: "To Time is required"});
      valid = false;
    }

    if(fromTime === "")
    {
      setErrMsg({...errMsg, ["fromTime"]: "From Time is required"});
      valid = false;
    }
    return valid;
  };


  function convertTo24Hour(timeValue: string) {
    const normalized = (timeValue || "").trim();
    if (!normalized) {
      return normalized;
    }

    const as24Hour = dayjs(normalized, "HH:mm", true);
    if (as24Hour.isValid()) {
      return as24Hour.format("HH:mm");
    }

    const as12Hour = dayjs(normalized, "hh:mm A", true);
    if (as12Hour.isValid()) {
      return as12Hour.format("HH:mm");
    }

    return normalized;
  }

  const normalizeDays = (daysList: string[] = []) =>
    daysList.map((day) => day?.toString().trim().toUpperCase()).filter((day) => !!day);

  const toMinutes = (timeValue: string) => {
    const normalized = timeValue.includes("AM") || timeValue.includes("PM")
      ? convertTo24Hour(timeValue)
      : timeValue;
    const [hours, minutes] = normalized.split(":").map((value) => Number(value));
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
      return null;
    }
    return hours * 60 + minutes;
  };

  const hasOverlap = (candidate: IThresholdCrossingSettingSchedule) => {
    const candidateDays = new Set(normalizeDays(candidate?.days || []));
    const candidateFrom = toMinutes(candidate.fromTime);
    const candidateTo = toMinutes(candidate.toTime);
    if (candidateDays.size === 0 || candidateFrom === null || candidateTo === null) {
      return false;
    }
    return scheduleList.some((existing) => {
      if (!existing) {
        return false;
      }
      if (candidate.id && existing.id === candidate.id) {
        return false;
      }
      const existingDays = new Set(normalizeDays(existing.days || []));
      const sharesDay = Array.from(candidateDays).some((day) => existingDays.has(day));
      if (!sharesDay) {
        return false;
      }
      const existingFrom = toMinutes(existing.fromTime);
      const existingTo = toMinutes(existing.toTime);
      if (existingFrom === null || existingTo === null) {
        return false;
      }
      return candidateFrom < existingTo && existingFrom < candidateTo;
    });
  };


   const submitHandler = async () => {
    if(handleValidate() && !errorsPresent)
    {
      let result : any
      try{
        let isNewSchedule = thresholdCrossingSettingScheduleData.id === null || thresholdCrossingSettingScheduleData.id === 0;
        const updatedData = {
        ...thresholdCrossingSettingScheduleData,
        fromTime: convertTo24Hour(thresholdCrossingSettingScheduleData.fromTime),
        toTime: convertTo24Hour(thresholdCrossingSettingScheduleData.toTime)
        };

          if (hasOverlap(updatedData)) {
            setErrMsg({ ...errMsg, overlap: "Overlapping schedule. A schedule with this time range already exists for this profile." });
            return;
          }

        setThresholdCrossingSettingScheduleData(updatedData);
        if (isNewSchedule) {
          result = await createThresholdCrossingSettingSchedule(thresholdCrossingSettingSchedulePayload(updatedData));
        }
        else
        {
          result = await updateThresholdCrossingSettingSchedule(thresholdCrossingSettingSchedulePayload(updatedData));
        }

        if (result?.error) throw result?.error;
          if (result.data?.status === 200 || result.data?.status === 201) {
           dispatch(setBasicDialogOpenFor(undefined));
            dispatch(setIsAddEditDeleteThresholdCrossingSettingSchedule(true));
            dispatch(
              setOpenToast({
                openToast: true,
                toastType: "success",
                message: `The Schedule has been ${isNewSchedule ? "added" : "updated"} for the profile.`,
              })
            );
          }

      }catch (error: any) {
          dispatch(setBasicDialogOpenFor(undefined));
          dispatch(setIsAddEditDeleteThresholdCrossingSettingSchedule(true));
          dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
      }
   }
  };

  const keys = [days, toTimes,fromTimes];
  const errorMsglist = keys.reduce((acc: IKeyValue, k) => {
    acc[k] = errorMsg[k] ?? '';
    return acc;
  }, {});
 const errorsPresent = Object.values(errorMsglist).some((err) => err !== "");
  return {
    thresholdCrossingSettingScheduleData,
    setThresholdCrossingSettingScheduleData,
    submitHandler,
    errMsg,
    setErrMsg,
    errorsPresent,
    days,
    fromTimes,
    toTimes
  };
};

export const useThresholdCrossingSettingRuleData = (selectedThresholdCrossingSettingRule: IThresholdCrossingSettingRule) => {

  const kpi = "kpi";
  const kpiType = "kpiType";
  const operator = "operator";
  const thresholdAbove = "thresholdAbove";
  const thresholdBelow = "thresholdBelow";
  const consecutiveSamples = "consecutiveSamples";

  const [thresholdCrossingSettingRuleData, setThresholdCrossingSettingRuleData] = useState<IThresholdCrossingSettingRule>(selectedThresholdCrossingSettingRule);
  const [errMsg, setErrMsg] = useState<IPayload>({});
  const errorMsg = useSelector(errorMsgSelector);

  const isAddEditDeleteThresholdCrossingSettingRule = useSelector(isAddEditDeleteThresholdCrossingSettingRuleSelector);
  const dispatch = useStoreDispatch();
  const [anchorElThresholdCrossingSettingRule, setAnchorElThresholdCrossingSettingRule] = useState<null | HTMLElement>(null);
  
  const deleteThresholdCrossingSettingRuleHandler = () => {
    dispatch(setConfirmDialog(DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGRULE));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.DELETETHRESHOLDCROSSINGSETTINGRULE))
    setAnchorElThresholdCrossingSettingRule(null);
  };

  const [createThresholdCrossingSettingRule, createThresholdCrossingSettingRuleStatus] = useCreateThresholdCrossingSettingRuleMutation();
  const [updateThresholdCrossingSettingRule, updateThresholdCrossingSettingRuleStatus] = useUpdateThresholdCrossingSettingRuleMutation();

  const handleValidate = () => {
    let valid: any = true;
    const kpiTypes = thresholdCrossingSettingRuleData?.kpiType;
    const kpis = thresholdCrossingSettingRuleData?.kpi;
    const above = thresholdCrossingSettingRuleData?.thresholdAbove;
    const below = thresholdCrossingSettingRuleData?.thresholdBelow;
    const consecutiveSamples = thresholdCrossingSettingRuleData?.consecutiveSamples;
    const hasAbove = above !== null && above !== undefined && String(above).trim() !== "";
    const hasBelow = below !== null && below !== undefined && String(below).trim() !== "";
  
    if(kpiTypes === "")
    {
      setErrMsg({...errMsg, ["kpiType"]: "Kpi type is required"});
      valid = false;
    }

    if(kpis === "")
    {
      setErrMsg({...errMsg, ["kpi"]: "Kpi is required"});
      valid = false;
    }
   
    if (!hasAbove && !hasBelow) {
      setErrMsg({...errMsg,["thresholdAbove"]: "At least thresholdAbove or thresholdBelow is required."
      });
      valid = false;
    }

    const selectedKpiList = kpiTypes === "LTE" ? LteKpiList : kpiTypes === "NR" ? NrKpiList : [];
    const selectedKpiItem = selectedKpiList.find((kpiItem) => kpiItem.kpi === kpis);
    if (selectedKpiItem) {
      if (selectedKpiItem.thresholdAbove) {
        if (!hasAbove) {
          setErrMsg({ ...errMsg, ["thresholdAbove"]: "thresholdAbove is required for this KPI." });
          valid = false;
        }
        if (hasBelow) {
          setErrMsg({ ...errMsg, ["thresholdBelow"]: "thresholdBelow is not allowed for this KPI." });
          valid = false;
        }
      } else {
        if (!hasBelow) {
          setErrMsg({ ...errMsg, ["thresholdBelow"]: "thresholdBelow is required for this KPI." });
          valid = false;
        }
        if (hasAbove) {
          setErrMsg({ ...errMsg, ["thresholdAbove"]: "thresholdAbove is not allowed for this KPI." });
          valid = false;
        }
      }
    }
    
    if (consecutiveSamples === null || consecutiveSamples === undefined) {
      setErrMsg({ ...errMsg, ["consecutiveSamples"]: `Consecutive samples is required.` });
      valid = false;
    }
    return valid;
  };

  const onBlurHandler = (event: any) => {
    const { name, value } = event?.target;
    const floatRegex = /^(\d+(\.\d*)?|\.\d+)$/;
    if((name === "thresholdAbove" || name === "thresholdBelow"))    
    {
      if(!floatRegex.test(value))
      {
        setErrMsg({ ...errMsg, [name]: "Only numbers and decimal values are allowed." });
        return;
      }
      if (parseFloat(value) < parseFloat(event.target.min) || parseFloat(value) > parseFloat(event.target.max)) {
        setErrMsg({ ...errMsg, [name]: `Invalid input. Please enter a value between ${event.target.min} and ${event.target.max}.` });
        return;
      }
    }  
  };

   const submitHandler = async () => {
    if(handleValidate() && !errorsPresent)
    {
      let result : any
      try{
        let isNewRule = thresholdCrossingSettingRuleData.id === null || thresholdCrossingSettingRuleData.id === 0;
        let updatedRule = { ...thresholdCrossingSettingRuleData };

        if (updatedRule.kpiType === "LTE") {
          const kpiItem = LteKpiList.find(k => k.kpi === updatedRule.kpi);

          if (kpiItem?.thresholdAbove) {
            updatedRule.thresholdBelow = null;
          } else {
            updatedRule.thresholdAbove = null;
          }
       }


      if (updatedRule.kpiType === "NR") {
        const kpiItem = NrKpiList.find(k => k.kpi === updatedRule.kpi);

        if (kpiItem?.thresholdAbove) {
          updatedRule.thresholdBelow = null;
        } else {
          updatedRule.thresholdAbove = null;
        }
      }

        if (isNewRule) {
          result = await createThresholdCrossingSettingRule(thresholdCrossingSettingRulePayload(updatedRule));
        }
        else
        {
          result = await updateThresholdCrossingSettingRule(thresholdCrossingSettingRulePayload(updatedRule));
        }

        if (result?.error) throw result?.error;
          if (result.data?.status === 200 || result.data?.status === 201) {
           
           dispatch(setBasicDialogOpenFor(undefined));
           dispatch(setIsAddEditDeleteThresholdCrossingSettingRule(true));
            dispatch(
              setOpenToast({
                openToast: true,
                toastType: "success",
                message: `The Rule has been ${isNewRule ? "added" : "updated"} successfully for ${titleCase(thresholdCrossingSettingRuleData.kpiType)}.`,
              })
            );
          }
      }catch (error: any) {
          dispatch(setBasicDialogOpenFor(undefined));
          dispatch(setIsAddEditDeleteThresholdCrossingSettingRule(false));
          dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error?.message ?? error?.data?.message ?? error) }));
      }
   }
  };

  const LteKpiList : IKpi[] =[
  {
    "kpi": "ERAB Establishment SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "VoLTE Establishment SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "RRC Connection Establishment SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "ERAB Drop Rate",
    "thresholdAbove": true,
    "dataType": "float",
    "minValue": 0,
    "maxValue": 99
  },
  {
    "kpi": "VoLTE Drop Rate",
    "thresholdAbove": true,
    "dataType": "float",
    "minValue": 0,
    "maxValue": 99
  },
  {
    "kpi": "HandIn Over S1 Interface SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "HandOut Over S1 Interface SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "Intra-Frequency X1 HO SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "Inter-Frequency X1 HO SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "LTE Cell Availability",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  }
]

 const NrKpiList : IKpi[] =[
  {
    "kpi": "SgNB Addition SR",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
  },
  {
    "kpi": "ENDC UE session drop rate",
    "thresholdAbove": true,
    "dataType": "float",
    "minValue": 0,
    "maxValue": 99
  },
  {
    "kpi": "Intra CU Handover Success Rate",
    "thresholdAbove": false,
    "dataType": "float",
    "minValue": 1,
    "maxValue": 100
    },
    {
      "kpi": "NR Cell Availability",
      "thresholdAbove": false,
      "dataType": "float",
      "minValue": 1,
      "maxValue": 100
  }
]


  const keys = [kpi, kpiType,operator,thresholdAbove,thresholdBelow,consecutiveSamples];
  const errorMsglist = keys.reduce((acc: IKeyValue, k) => {
    acc[k] = errorMsg[k] ?? '';
    return acc;
  }, {});
  const errorsPresent = Object.values(errorMsglist).some((err) => err !== "");

  return {
    thresholdCrossingSettingRuleData,
    setThresholdCrossingSettingRuleData,
    submitHandler,
    onBlurHandler,
    errMsg,
    setErrMsg,
    errorsPresent,
    anchorElThresholdCrossingSettingRule,
    setAnchorElThresholdCrossingSettingRule,
    deleteThresholdCrossingSettingRuleHandler,
    kpi,
    kpiType,
    operator,
    thresholdAbove,
    thresholdBelow,
    consecutiveSamples,
    LteKpiList,
    NrKpiList
   };
};


